/* istanbul ignore file */
import { StyledFiltersRow, StyledHeader, StyledTotal } from './Header.style';
import TableTypeToggler from './filters/TableTypeToggler';
import InsightFilterIndicator from './filters/InsightFilterIndicator';
import { useContext } from 'react';
import ProjectProgressionContext from '../../state/context';
import { onRemoveInsightFilter } from '../../state/actions';
import StatePicker from './filters/StatePicker/StatePicker';
import LineLoader from './LineLoader';
import SearchKeyword from './filters/SearchKeyword';

const Header = ({
  tableType,
  setTableType,
  stateTypes,
  onClickStateType,
  keyword,
  setKeyword,
  data,
  isLoading
}) => {
  const {
    state: { selectedInsightKey },
    dispatch
  } = useContext(ProjectProgressionContext);

  const total = data?.total ?? 'N/A';
  const totalCategories = data?.categories || {};

  return (
    <StyledHeader>
      <StyledFiltersRow>
        <TableTypeToggler
          tableType={tableType}
          onChange={tableType => setTableType(tableType)}
        />
        <SearchKeyword value={keyword} onChange={setKeyword} />
      </StyledFiltersRow>

      <StyledFiltersRow>
        {isLoading ? (
          <LineLoader />
        ) : (
          <>
            <StyledTotal>
              {total} {tableType.name}
            </StyledTotal>
            <StatePicker
              stateTypes={stateTypes}
              onClickStateType={onClickStateType}
              totalCategories={totalCategories}
            />
            {selectedInsightKey && (
              <InsightFilterIndicator
                insightKey={selectedInsightKey}
                onRemove={() => dispatch(onRemoveInsightFilter())}
              />
            )}
          </>
        )}
      </StyledFiltersRow>
    </StyledHeader>
  );
};

export default Header;
